module.exports = __webpack_public_path__ + "img/vive.3c47bde6.png";